export enum SkeletonTypeEnum {
  TEXT = 'text',
  INPUT = 'input',
  IMAGE = 'image',
}
